import styled from 'styled-components';
import { Form as UnformForm } from '@unform/web';

interface IButtonConfirmProps {
  status: string; // ou 'open' | 'closed' se os valores forem fixos
}

interface ITabProps {
  active?: boolean;
}

export const Tabs = styled.div`
  display: flex;
  gap: 12px;
  margin: 24px 0;
  border-bottom: 2px solid #ddd;
`;

export const Tab = styled.button<ITabProps>`
  padding: 12px 20px;
  font-size: 16px;
  background: transparent;
  border: none;
  border-bottom: 3px solid
    ${({ active }) => (active ? '#7284ff' : 'transparent')};
  color: ${({ active }) => (active ? '#000' : '#666')};
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};

  &:hover {
    color: #000;
  }
`;

export const Container = styled.div`
  padding: 0 20px 40px;

  table {
    width: 100%;
    border-spacing: 0;
    margin-top: 24px;
  }

  table th {
    font-size: 22px;
    text-align: left;
    font-weight: 400;
    background: #f1f1f1;
    padding: 10px;

    & + th {
      border-left: 1px solid #ddd;
    }
  }

  table td {
    font-size: 16px;
    padding: 10px;
  }

  table tr {
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f0f0f0;
    }

    &:nth-child(even) td {
      background: #f5f5f5;
    }

    &:nth-child(even):hover td {
      background: #f0f0f0;
    }
  }

  table th:last-child,
  table td:last-child {
    text-align: right;
  }
`;

export const Filters = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;

  margin-top: 24px;

  button {
    display: flex;
    align-items: center;
    height: 45px;

    border-radius: 8px;
    border: 1px solid transparent;
    padding: 0 16px;
    background: #e1e1e1;
    cursor: pointer;

    &:first-child {
      color: #fff;
      border-color: #f6c866;
      background: #f6c866;

      &:hover {
        background: #e5b855;
      }
    }

    &:hover,
    &:active {
      border-bottom-color: #ccc;
    }

    &[disabled] {
      cursor: default;
    }
  }

  button:active {
    transform: scale(0.98);
    top: 10px;
  }

  svg {
    margin-right: 8px;
  }
`;

export const FiltersWrapper = styled(UnformForm)`
  display: flex;
  align-items: end;
  gap: 8px;
`;

export const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 22px;
  background: #f5f5f5;
  padding: 50px 0;
  border-radius: 0 0 8px 8px;
`;

export const Wrapper = styled.div`
  display: flex;

  color: #666;
  margin-top: 24px;
  padding: 12px 32px;

  section {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      width: 100%;
      padding: 0 42px;
    }

    & + section div {
      border-left: 1px solid #efefef;
    }
  }

  strong {
    display: block;

    font-size: 52px;
    font-weight: 700;
  }
`;

export const ContainerCircle = styled.div`
  position: relative;
  display: inline-block;

  margin-right: 24px;

  svg circle:nth-child(2) {
    animation: circle-chart-fill 2s reverse;
    transform: rotate(-87deg);
    transform-origin: center;
  }

  svg + svg {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
  }

  @keyframes circle-chart-fill {
    to {
      stroke-dasharray: 0 100;
    }
  }
`;

export const ButtonConfirm = styled.button<IButtonConfirmProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 23px;
  height: 23px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: ${props => {
    if (props.status === 'resolved') return 'rgb(0, 102, 255)';
    if (props.status === 'closed') return 'rgb(0, 102, 255)';
    return 'rgb(177, 177, 177)';
  }};
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;

  &:hover,
  &:active {
    border-bottom-color: #ccc;
  }

  &[disabled] {
    cursor: default;
  }

  svg {
    margin-right: 8px;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;

    h2 {
      font-size: 24px;
      color: #333;
    }

    button {
      background: none;
      border: none;
      font-size: 24px;
      color: #666;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;

      &:hover {
        background: #f5f5f5;
        color: #333;
      }
    }
  }

  div {
    font-size: 16px;
    line-height: 1.6;
    color: #333;

    /* Estilização básica para conteúdo HTML */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 16px 0 8px;
      color: #222;
    }

    p {
      margin: 8px 0;
    }

    ul,
    ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    img {
      max-width: 100%;
      height: auto;
      margin: 16px 0;
    }

    a {
      color: #7284ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin: 16px 0;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f6c866;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background: #e5b855;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  svg {
    margin-right: 4px;
  }
`;

export const Form = styled(UnformForm)`
  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: #333;
    }

    input[type='text'] {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;

      &:focus {
        border-color: #7284ff;
        outline: none;
      }
    }

    input[type='checkbox'] {
      margin-right: 8px;
    }

    .tox-tinymce {
      border-radius: 4px;
      border-color: #ddd;

      &:focus-within {
        border-color: #7284ff;
      }
    }
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solidrgb(233, 233, 233);
  border-radius: 6px;
  font-size: 1rem;
  background: rgb(255, 255, 255);
  color: #333;
  transition: border 0.2s;
  outline: none;
  margin-top: 4px;
  margin-bottom: 8px;

  &:focus {
    border-color: #e0a800;
    background: #fff7d1;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin: 18px 0 24px 0;

  label {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #333;
    font-size: 1rem;
  }

  input[type='checkbox'] {
    margin-right: 12px;
    width: 18px;
    height: 18px;
    accent-color: #f6c866;
  }
`;
